// What the video call screen does for each Daily event (brief 016). Kept apart from
// VideoCall.js so it can be tested without Firebase or Daily.
//   'close'  — leave the call screen and go back where the user came from
//   'camera' — camera or mic blocked: explain, with Try again and Back
export function callEventAction(event) {
  switch (event?.action) {
    case 'left-meeting':
    case 'error':
      return 'close';
    case 'camera-error':
      return 'camera';
    default:
      return null;
  }
}

// Daily Prebuilt in MedXMeet's colours (design review I3).
export const CALL_THEME = {
  colors: {
    accent: '#0F6B52',
    accentText: '#FFFFFF',
    background: '#121417',
    backgroundAccent: '#1E2125',
    baseText: '#FFFFFF',
    border: '#2A2D31',
    mainAreaBg: '#121417',
    supportiveText: '#9A9F98',
  },
};
